/**
 * Этажи на боковом язычке (25.09, просьба владельца «как кнопка SOS»): чистая
 * логика подписи язычка и места панели выбора — отдельно от компонента
 * (mall-explorer.tsx), чтобы проверять тестом без DOM.
 */
import { floorNumberOfLevel, type Venue } from '@app/rvf'
import { DOCK_RAIL } from './edge-dock'

/** Высота язычка, px: одна цифра для вёрстки (.floor-tab) и расчёта панели. */
export const FLOOR_TAB_HEIGHT = 60

/** Верх язычка на дорожке дока — та же формула, что у SOS и прежнего рельса. */
export function floorTabTop(ratio: number): string {
  return `calc(env(safe-area-inset-top) + 96px + ${ratio} * (${DOCK_RAIL}))`
}

/**
 * Подпись на язычке: номер этажа, как на табличках в здании (−1/1/2, без
 * нуля — floorNumberOfLevel), или null = «Все». Номер, а не имя уровня: в
 * 44 px ширины «Паркинг» не помещается, полное имя видно в панели выбора.
 * Уровень, которого в площадке нет (выбор остался от другой площадки), — «Все».
 */
export function floorTabNumber(v: Venue, activeLevelId: string | null): string | null {
  if (activeLevelId === null) return null
  if (!v.levels.some((l) => l.id === activeLevelId)) return null
  return String(floorNumberOfLevel(v, activeLevelId))
}

/** Место панели выбора: задан либо top (растёт вниз), либо bottom (вверх). */
export interface FloorPopPlacement {
  top?: string
  bottom?: string
  maxHeight: string
}

/**
 * Где раскрыть панель выбора. Язычок в верхней половине дорожки — панель
 * растёт вниз от его верха, в нижней — вверх от его низа: так она не уходит
 * за край экрана при любом положении язычка. max-height с прокруткой держит
 * её в экране и у площадок с 5+ этажами на низких экранах (360×640).
 */
export function floorPopPlacement(ratio: number): FloorPopPlacement {
  const top = floorTabTop(ratio)
  if (ratio <= 0.5) {
    return { top, maxHeight: `calc(100vh - ${top} - env(safe-area-inset-bottom) - 16px)` }
  }
  const tabBottom = `(${top} + ${FLOOR_TAB_HEIGHT}px)`
  return {
    bottom: `calc(100vh - ${tabBottom})`,
    maxHeight: `calc(${tabBottom} - env(safe-area-inset-top) - 16px)`,
  }
}
